var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-field',{staticClass:"typo-roboto",attrs:{"label":_vm.$t('interval.label')}},[_c('vca-selection',{attrs:{"selection":_vm.intervals},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }